
    import '/vercel/path0/docs/theme/market.md?watch=parent';
    export const toc = [{"id":"dumi-主题市场","depth":2,"title":"Dumi 主题市场"},{"id":"更多主题","depth":2,"title":"更多主题"}];
export const frontmatter = {"title":"主题市场","toc":null,"filename":"docs/theme/market.md","lastUpdated":1717482106000,"group":"介绍","order":4,"description":"为 dumi 设计的主题"};